import { Injectable, inject, signal } from '@angular/core';
import { PageNavigatorService } from '@comparit/shared';
import { HausratRoutes } from '../app/app.routes.paths';
import { FormsService } from './forms.service';

/** Every step route in formular.routes.ts, step1 — the Willkommen screen — included. */
export const TOTAL_STEPS = 11;

@Injectable({ providedIn: 'root' })
export class StepInitService {
  private readonly pageNavigatorService = inject(PageNavigatorService);
  private readonly formsService = inject(FormsService);

  currentStep = signal<number>(0);

  initStep(step: number): void {
    this.currentStep.set(step);

    this.pageNavigatorService.setup.set({
      backLink: { url: step === 1 ? null : HausratRoutes.step(step - 1), disabled: step === 1 },
      info: `Schritt ${step - 1} von ${TOTAL_STEPS - 1}`,
      forward: {
        // The last step leads into the results page.
        url: step === TOTAL_STEPS ? HausratRoutes.rechner : HausratRoutes.step(step + 1),
        // The navigator withholds the route while a step is invalid; this is what tells the
        // customer why nothing happened.
        action: {
          callback: () => {
            this.pageNavigatorService.revealBlockingStep({
              allFgs: this.formsService.allFgs,
              step,
              formularUrl: HausratRoutes.formular,
            });
          },
        },
      },
    });
  }
}
